import styled from 'styled-components'

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
  width: 100%;
`
